import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Typography, Button, Grid, Autocomplete, TextField } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import GeneratePayout from './GeneratePayout'
import { useSnackbar } from 'notistack'
import SendIcon from '@mui/icons-material/Send'
import {
  useGetSalesPayouts,
  useSendBulkPayoutEmails,
  useExportSalesPayouts
} from '../../../api/sales-commission-incentive'
import { ExportButton } from '../../../component/shared/component/ExportButton'
import { getErrorMessage } from '../../../api/utils'
import { Navbar } from '../../../component/shared/Navbar'
import { PageContainer } from '../../../component/styled/PageContainer'
import Breadcrumb from '../../../component/shared/Breadcrumb'
import { getRecentMonths } from '../../../utils/date'

export const Payout = () => {
  const monthOptions = getRecentMonths(12)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [monthYear, setMonthYear] = useState(monthOptions[0].value)

  const { mutateAsync } = useSendBulkPayoutEmails()
  const { mutateAsync: exportPayouts } = useExportSalesPayouts()
  const { data = [], isLoading, refetch } = useGetSalesPayouts({ monthYear })

  const { enqueueSnackbar } = useSnackbar()

  const handleGeneratePayouts = () => setConfirmOpen(true)

  const handleSendBulkEmail = async () => {
    try {
      await mutateAsync({ monthYear })
      await refetch()
      enqueueSnackbar(
        'Bulk email process started in the background. This may take up to 5 minutes per user. Please check back later for updates.',
        { variant: 'info' }
      )
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' })
    }
  }

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Sales Payout</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} paddingTop={5}>
          <Grid item xs={12}>
            <Breadcrumb items={[{ label: 'Payout' }]} />
            <Typography variant='h1'>Payout</Typography>
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <Autocomplete
              options={monthOptions}
              value={monthOptions.find((option) => option.value === monthYear)}
              onChange={(_, { value }) => value && setMonthYear(value)}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} variant='outlined' fullWidth />}
              fullWidth
              disableClearable={true}
            />
            <Button
              variant='contained'
              color='primary'
              onClick={handleGeneratePayouts}
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              size='large'
            >
              GENERATE
            </Button>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} gap={2}>
            <ExportButton
              exportFn={() => exportPayouts({ monthYear })}
              filename={`Sales_Payouts_${monthYear}.xlsx`}
            />
            <Button startIcon={<SendIcon />} onClick={handleSendBulkEmail}>
              Send Payout Emails
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table data={data} isLoading={isLoading} refetch={refetch} />
          </Grid>
        </Grid>
      </PageContainer>
      <GeneratePayout
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        monthYear={monthYear}
        refetch={refetch}
      />
    </>
  )
}
